export default "__VITE_ASSET__93bBg3Eq__";